import { createI18n } from 'vue-i18n'
import bg from './locales/bg.json'
import cy from './locales/cy.json'
import de from './locales/de.json'
import de_CH from './locales/de_CH.json'
import en from './locales/en.json'
import es from './locales/es.json'
import et from './locales/et.json'
import fr from './locales/fr.json'
import ga from './locales/ga.json'
import gu from './locales/gu.json'
import hi from './locales/hi.json'
import hu from './locales/hu.json'
import lt from './locales/lt.json'
import lv from './locales/lv.json'
import nl from './locales/nl.json'
import pl from './locales/pl.json'
import ro from './locales/ro.json'
import sk from './locales/sk.json'
import tr from './locales/tr.json'
import uk from './locales/uk.json'
import zh_CN from './locales/zh_CN.json'
import zh_TW from './locales/zh_TW.json'

export default createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    bg,
    cy,
    de,
    de_CH,
    et,
    es,
    fr,
    ga,
    gu,
    hi,
    hu,
    lt,
    lv,
    nl,
    pl,
    ro,
    sk,
    tr,
    uk,
    zh_CN,
    zh_TW,
  },
  warnHtmlMessage: false, // We handle the HTML sanitization through dompurify
  missingWarn: false, // Disable default missing warnings
  fallbackWarn: false, // Disable default fallback warnings
})
